// extracted by mini-css-extract-plugin
export var activeFilterButton = "_m6-c";
export var backButton = "_m6-4";
export var backIcon = "_m6-5";
export var chevronShortcut = "_m6-6";
export var container = "_m6-1";
export var editor = "_m6-8";
export var editorWrapper = "_m6-7";
export var prefix = "_m6-2";
export var searchIcon = "_m6-3";
export var suffix = "_m6-9";
export var suffixContent = "_m6-a";
export var suffixText = "_m6-b";
export var wrapper = "_m6-0";